module.exports = __webpack_public_path__ + "static/media/311.5e2767b7.svg";